export const GA_TRACKING_ID = 'G-FKC8E54ZH6';
export const GTM_TRACKING_ID = 'GTM-TSX4QKV';
// process.env.GTM_ID

// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (url) => {
  if (typeof window.gtag !== 'undefined'){
    window.gtag("config", GA_TRACKING_ID, {
      page_path: url,
    });
    console.log("test gtg:", GA_TRACKING_ID, "-"+url);
  }
  
  //   if (typeof window.dataLayer !== "undefined") {
  //       window.dataLayer.push({
  //           event: "gtm.load",
  //           page_location: url,
  //           page: url,
  //       })
  // } else {
  //   console.log({
  //     event: "pageview",
  //     page: url,
  //   })
  // }
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = ({action, category, label, value }) => {
    window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
    })
    console.log("event", action, value);
}